import { useMemo } from 'react'
import useLatest from 'react-use/lib/useLatest'

import { createContainer } from '../utils'

export const useElementRef = (
  containerClassName?: string,
  containerStyle?: Partial<CSSStyleDeclaration>
) => {
  const container = useMemo(
    () => createContainer(containerStyle, containerClassName),
    [containerClassName, containerStyle]
  )

  return useLatest(container)
}
